import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import {
    makeRequest,getErrorCode,
    dispatchAction,
    displayMessage
} from 'actions';
import {Tabs, Tab, Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import config from  '../../config';
import {  Link } from 'react-router';


import {USER_LOGOUT,
    UPDATE_USER_DATA
} from "actions/actionTypes";




class PartnerDashboardPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
        this.state={
            userDataReceived:_.get(this.props.userReducer, ['user', '_id'], false) ? true:false,
        }
      };
    componentWillMount() {
        console.log('in dashboard', _.get(this.props, ['location', 'query', 'customerid'], false), this.props.userReducer );
        /* get user data if  user._id is not available and customer id is passed */
        /* or if  user._id is available and passed customer id is not equal to current user ShopifyCustomerID, can happen if user logs in to another account on Shopify */
        if(_.get(this.props, ['location', 'query', 'customerid'], false)){
            if ((!_.get(this.props.userReducer, ['user', '_id'], false) && _.get(this.props, ['location', 'query', 'customerid'], false))
                || (_.get(this.props.userReducer, ['user', '_id'], false) && _.get(this.props, ['location', 'query', 'customerid'], false) && _.get(this.props, ['location', 'query', 'customerid'], false) !== _.get(this.props.userReducer, ['user', 'ShopifyCustomerID'], false))
            ) {
                this.props.dispatchAction({}, USER_LOGOUT)
                /* remove token for the current user */
            }
            this.setState({userDataReceived:false})
            var methodData = {
                'endpoint': '/get-user-data-with-query',
                "success_event": UPDATE_USER_DATA,
                'type': 'post',
                'not_display_error_message': true,
            };
            this.props.makeRequest({ShopifyCustomerID: _.get(this.props, ['location', 'query', 'customerid'], false)}, methodData).then(res => {
                console.log('userDataReceived', res  );
                if (!_.get(res.data, 'User._id')){
                    this.props.displayMessage({
                        'messageType': 'warning',
                        'messageCode': 'User not found by ID: ' + _.get(this.props, ['location', 'query', 'customerid'], false)

                    });
                }
                this.setState({userDataReceived:true})
            }).catch(err =>{
                if( config.apiErrorCodeMap[getErrorCode(err)] == 'RecordNotFound'){
                    this.setState({userDataReceived: true, userNotFound: true})
                }
            })

        }
        if ( config.getEnvironmentName() == 'local' ||   window.self != window.top) {
            window.self.document.body.classList.add('in-frame');
        }
    }


    render() {
        console.log('this.props.userReducer', _.get(this.props, ['location' ], false), this.props.userReducer, this.state.userDataReceived);
        if (!this.state.userDataReceived) {
            return null
        }
        if (!_.get(this.props.userReducer, ['user', '_id'], false)) {
            if (_.get(this.state, 'userNotFound')) {
                this.sendDataForIframe()
                return <h3 className="message-box">Sorry, user record not found</h3>
            }
            return null;


        } else {
            if (!_.get(this.props.userReducer, ['seller', '_id'], false) &&  /dashboard\/products|dashboard\/services|dashboard\/settings/i.test(this.props.location.pathname)){
                console.log('not seller'  );
                this.sendDataForIframe()
                return <div>
                    <div className="message-box">
                        <a className="btn btn-primary" target="_blank"
                           href={ 'https://goodbuygear.com/pages/schedule-a-white-glove-pickup-service'}>Sign-up to Sell</a>
                    </div>

                </div>
            }



            return (
                <div
                    className=" "
                >
                     {/*<div className="navigation-box left10  bot15">*/}
                    {/*<Button bsStyle="link" className="nav-box-header">*/}
                        {/*<Link to={'/client/data/products'}>Products</Link>*/}
                    {/*</Button>*/}

                {/*</div>*/}


                    <div className="container"> {this.props.children }  </div>
                </div >
            );
        }
    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
     };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerDashboardPage);
